const urlEncode = function convertStringToURLFormat(string) {
  return string
    .replace(/-|\.|:|&/g, '')
    .replace(/\s+/g, '-')
    .toLowerCase();
};

export default urlEncode;
